import * as Sentry from "@sentry/vue"

export default defineNuxtPlugin((nuxtApp) => {
	const app = useNuxtApp()
	const runtimeConfig = useRuntimeConfig()
	Sentry.init({
		app: nuxtApp.vueApp,
		dsn: runtimeConfig.public.sentryDsn,
		enabled: !runtimeConfig.public.dev,
		environment: runtimeConfig.public.dev ? "development" : "production",
		integrations: [
			new Sentry.BrowserTracing({
				tracePropagationTargets: ["localhost", runtimeConfig.public.siteUrl],
				routingInstrumentation: Sentry.vueRouterInstrumentation(app.$router)
			}),
			new Sentry.Replay()
		],
		tracesSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
		beforeSend(event, hint) {
			if (event.exception) {
				console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint })
			}
			return event
		}
	})
})
